import React, { useState, useEffect } from "react";
import axios from "../../axiosInstance"; // Ensure axios is configured correctly
import "./AdsBanner_mid.css";

const AdsBanner_mid = ({ placement, page }) => {
  const [ads, setAds] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL || "https://todaylocal.in/api";
  const district = localStorage.getItem("district");

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await axios.get("/api/admin/ads/display", {
          params: { placement, page, district },
        });

        if (response.data?.success && response.data.ads.length > 0) {
          setAds(response.data.ads);
        } else {
          console.warn("No ads found:", response.data.message);
          setAds([]);
        }
      } catch (error) {
        console.error("Error fetching ads:", error.message);
      }
    };

    fetchAds();
  }, [placement, page, district]);

  return (
    <div className="user-mid-ads-banner">
      <div className="user-mid-ads-container">
        {ads.length > 0 ? (
          ads.map((ad, index) =>
            ad.ads.map((adItem, subIndex) => (
              <a
                href={adItem.url || "#"}
                key={`${index}-${subIndex}`}
                className="user-mid-ad-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${BASE_URL}/${adItem.image}`} // Ensure correct path
                  alt={adItem.alt || `Ad ${index + 1}`}
                  className="user-mid-ad-image"
                />
              </a>
            ))
          )
        ) : (
          <p className="no-ads-message">No ads available at the moment.</p>
        )}
      </div>
    </div>
  );
};

export default AdsBanner_mid;
